module.exports = __webpack_public_path__ + "img/18.c47c412d.gif";